/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const noRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Be om å legge til skole',
    description: 'Vennligst fyll ut skjemaet nedenfor. Skoler som er sendt inn er ikke garantert å bli lagt til, men alle forespørsler blir undersøkt og vurdert av SheerID. ',
    noCountry: 'Ser du ikke landet skolen befinner seg i? Du er ikke kvalifisert for dette tilbudet',
    searchByOrgName: 'Ser du ikke skolen din? Søk med navn',
    completeRequest: 'Ser du ikke skolen din på listen over kvalifiserte eller ukvalifiserte skoler? Fullfør forespørselen',
    submit: 'Send inn',
    eligibleOrgs: 'Kvalifiserte skoler. Klikk på ikonet for å kopiere navnet og gå tilbake til bekreftelsesskjemaet',
    ineligibleOrgs: 'Ukvalifiserte skoler. Vi beklager, elever ved disse skolene er ikke kvalifisert for tilbudet',
    none: 'Ingen',
    country: 'Hvor går du på skole?',
    changeLanguage: 'Skifte språk',
    copied: 'Kopiert',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    emailAddress: 'E-post',
    poweredBy: 'Verifikasjonstjenester drevet av SheerID',
    fields: {
        countryPlaceholder: 'Velg land',
        domainLabel: 'Skolens hjemmeside',
        domainPlaceholder: 'wwww.myschool.no',
        orgNameLabel: 'Navn på skole',
        orgNamePlaceholder: 'Min skole',
    },
    step: {
        success: {
            title: 'Takk for at du sendte forespørselen for din skole',
            description: 'Vi minner om at hver forespørsel evalueres av SheerID i samsvar med kravene for dette tilbudet. Vi kan ikke garantere at skolen din legges til. Evalueringsprosessen tar opptil 7 dager.',
        },
        error: {
            title: 'Det oppstod en uventet feil ',
            description: 'Beklager, vi kan ikke behandle forespørselen din. Vennligst prøv igjen senere.',
            seeingProblem: 'Hvis du fortsetter å se dette problemet',
            contactUs: 'kontakt oss',
        },
    },
    errorId: {
        invalidCountry: 'Feltet er påkrevet',
        invalidEmail: 'Ugyldig E-post',
        invalidFirstName: 'Ugyldig fornavn',
        invalidLastName: 'Ugyldig etternavn',
        requiredField: 'Feltet er påkrevet',
        invalidField: 'Feltet er ugyldig',
        invalidUrl: 'Ugyldig URL',
        tooManyResults: 'Søket ditt ga for mange resultater, vennligst begrens søket ditt og prøv igjen',
    },
    faq: 'SheerID Legg til spørsmål om skoleforespørsel',
    countries: {
        AD: 'Andorra',
        AE: 'De forente arabiske emirater',
        AF: 'Afghanistan',
        AG: 'Antigua og Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'De nederlandske Antillene',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'Amerikansk Samoa',
        AT: 'Østerrike',
        AU: 'Australia',
        AW: 'Aruba',
        AZ: 'Aserbajdsjan',
        BA: 'Bosnia-Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgia',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brasil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Hviterussland',
        BZ: 'Belize',
        CA: 'Canada',
        CD: 'Den demokratiske republikken Kongo',
        CF: 'Den sentralafrikanske republikk',
        CG: 'Kongo',
        CH: 'Sveits',
        CI: 'Elfenbenskysten (Elfenbenskysten)',
        CK: 'Cook-øyene',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Kina',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Kapp Verde',
        CY: 'Kypros',
        CZ: 'Tsjekkisk Republikk',
        DE: 'Tyskland',
        DJ: 'Djibouti',
        DK: 'Danmark',
        DM: 'Dominica',
        DO: 'Den dominikanske republikk',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Egypt',
        EH: 'Vest Sahara',
        ER: 'Eritrea',
        ES: 'Spania',
        ET: 'Etiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falklandsøyene',
        FM: 'Mikronesia',
        FO: 'Færøyene',
        FR: 'Frankrike',
        GA: 'Gabon',
        GB: 'Storbritannia',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'Fransk Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grønland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (fransk)',
        GQ: 'Ekvatorial-Guinea',
        GR: 'Hellas',
        GS: 'Sør-Georgia og Sør-Sandwichøyene',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard og McDonald Islands',
        HN: 'Honduras',
        HR: 'Kroatia',
        HT: 'Haiti',
        HU: 'Ungarn',
        ID: 'Indonesia',
        IE: 'Irland',
        IL: 'Israel',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Island',
        IT: 'Italia',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kirgisistan',
        KH: 'Kambodsja',
        KI: 'Kiribati',
        KM: 'Komorene',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'Nord-Korea',
        KR: 'Sør-Korea',
        KW: 'Kuwait',
        KY: 'Caymanøyene',
        KZ: 'Kasakhstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litauen',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldova',
        ME: 'Montenegro',
        MG: 'Madagaskar',
        MH: 'Marshalløyene',
        MK: 'Makedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macau',
        MP: 'Nord-Marianene',
        MQ: 'Martinique (fransk)',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldivene',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mosambik',
        NA: 'Namibia',
        NC: 'Ny-Caledonia (fransk)',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Nederland',
        NO: 'Norge',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesia (fransk)',
        PG: 'Papua Ny-Guinea',
        PH: 'Filippinene',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint Pierre og Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PS: 'Palestina',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Runion (fransk)',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russland',
        RW: 'Rwanda',
        SA: 'Saudi-Arabia',
        SB: 'Solomon øyene',
        SC: 'Seychellene',
        SD: 'Sudan',
        SE: 'Sverige',
        SG: 'Singapore',
        SH: 'St. Helena',
        SI: 'Slovenia',
        SK: 'Slovenske republikk',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        SS: 'Sør-Sudan',
        ST: 'Saint Tome (Sao Tome) og Principe',
        SV: 'El Salvador',
        SY: 'Syria',
        SZ: 'Swaziland',
        TC: 'Turks- og Caicosøyene',
        TD: 'Tsjad',
        TF: 'Franske sørlige territorier',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tadsjikistan',
        TK: 'Tokelau',
        TL: 'Øst-Timor',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Tyrkia',
        TT: 'Trinidad og Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraina',
        UG: 'Uganda',
        UM: 'USA Mindre ytre øyer',
        US: 'USA',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VA: 'Vatikanstaten',
        VC: 'Saint Vincent og Grenadinene',
        VE: 'Venezuela',
        VG: 'Jomfruøyene (britiske)',
        VI: 'Jomfruøyene (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis og Futuna øyene',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Sør-Afrika',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: 'Arabisk',
        bg: 'Bulgarsk',
        cs: 'Tjekkisk',
        da: 'Dansk',
        de: 'Tysk',
        el: 'Gresk',
        'en-GB': 'Engelsk (Storbritannia)',
        'en-US': 'Engelsk',
        'es-ES': 'Spansk (Spania)',
        es: 'Spansk',
        fi: 'Finsk',
        'fr-CA': 'Fransk (kanadisk)',
        fr: 'Fransk',
        hr: 'Kroatisk',
        hu: 'Ungarsk',
        id: 'Indonesisk',
        is: 'Islandsk',
        it: 'Italiensk',
        iw: 'Hebraisk',
        ja: 'Japansk',
        ko: 'Koreansk',
        lt: 'Litauisk',
        ms: 'Malaysisk',
        nl: 'Nederlandsk',
        no: 'Norsk',
        pl: 'Polsk',
        'pt-BR': 'Portugisisk (Brasil)',
        pt: 'Portugisisk',
        ro: 'Rumensk',
        ru: 'Russland',
        sk: 'Slovakisk',
        sl: 'Slovensk',
        sr: 'Serbisk',
        sv: 'Svensk',
        tr: 'Tyrkisk',
        'zh-HK': 'Kinesisk (Hong Kong)',
        zh: 'Tradisjonell kinesisk)',
    },
};
